import { API_ENDPOINTS } from "./api-endpoints";
import { StaffResponse } from "src/dataModels/clientResponse";
import { customAxios } from "./useExPressApi";
import { GetActiveStaffSeatsResponse, ServiceSetDDLResponse, StaffNotificationPayloadModel } from "src/dataModels/staffResponsesModels";

export const staffServicess = {
    activeStaffSeats: (id?: string) => {
        return customAxios.get<any, GetActiveStaffSeatsResponse>(`${API_ENDPOINTS.GET_ACTIVE_STAFF_SEATS}`);
    },
    serviceSetDDL: (serviceSetFor: string) => {
        return customAxios.get<ServiceSetDDLResponse>(`${API_ENDPOINTS.GET_SERVICE_SET_DDL}${serviceSetFor}`);
    },
    getstaffNotificationSetting: (data: any) => {
        return customAxios.get<ServiceSetDDLResponse>(`${API_ENDPOINTS.GET_STAFF_NOTIFICATION_SETTING}?staffId=${data?.staffId}&alertType=${data?.alertType}`);
    },
    savestaffNotification: (data: StaffNotificationPayloadModel) => {
        return customAxios.post<ServiceSetDDLResponse>(`${API_ENDPOINTS.INSERT_STAFF_NOTIFICATION_SETTING}`, data);
    },
    getstaffNotificationMediumSetting: (staffId: any) => {
        return customAxios.get<ServiceSetDDLResponse>(`${API_ENDPOINTS.GET_STAFF_NOTIFICATION_MEDIUM_SETTING}?staffId=${staffId}`);
    },
    saveStaffNotificationMediumSettings: (data: any) => {
        return customAxios.post<ServiceSetDDLResponse>(`${API_ENDPOINTS.INSERT_STAFF_NOTIFICATION_MEDIUM_SETTING}`, data);
    },
    staffList: () => {
        return customAxios.get<any, StaffResponse>(`${API_ENDPOINTS.GET_STAFF_DDL_BY_CLINIC_ID}true`);
    },


}